import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../../app.config';
import { HangfireJob } from './hangfire.model';

@Injectable({
  providedIn: 'root',
})
export class HangfireService {
  constructor(private http: HttpClient, private toastrService: ToastrService) {}

  deleteHangfireJob(payload: HangfireJob) {
    return this.http.post<boolean>(`${AppConfig.settings.settings.apiEndpoint}Hangfire/DeleteHangfireJob`, payload).pipe(map(data => {
      return data
    }));
  }

  createHangfireJob(payload: HangfireJob): Observable<any> {
    return this.http
      .post<number>(`${AppConfig.settings.settings.apiEndpoint}Hangfire/PostHangfireJob`, payload)
      .pipe(
        map(data => {
          if (data == 0 || data == null) {
            this.toastrService.error('Something went wrong. Try again.', '');
          } else {
            this.toastrService.success('Saved successfully.', '');
          }
          return data;
        })
      );
  }

  getHangfireJobs(): Observable<HangfireJob[]> {
    return this.http
      .get<HangfireJob[]>(`${AppConfig.settings.settings.apiEndpoint}Hangfire/GetHangfireJobs`)
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
